/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Col,
  Tooltip,
  Spin,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  INCIDENCIA_AUSENTISMO,
  INCIDENCIA_VACACIONES,
  INCIDENCIA_INCAPACIDAD,
  INCIDENCIA_PAGOLABORAL,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { checkToken } from 'api/utils';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import SectionCard from '../../SectionCard';
import Select from '../../Select';
import IncidenciaPercepcion from './IncidenciaPercepcion';

// eslint-disable-next-line react/prop-types
const IncidenciaParametros = ({
  form,
  rules,
  selectedPercepciones,
  disabled,
  incidenciaId,
}) => {
  const [loading, setLoading] = useState(false);
  const [tiposPercepcion, setTiposPercepciones] = useState([]);
  const [descuentos, setDescuentos] = useState([]);
  const [aplicaDescuentoEnNomina, setAplicaDescuentoEnNomina] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const esIncapacidadMedica = Form.useWatch('es_una_incapacidad_medica', form);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tiposPercepcion,
        _descuentos,
      ] = await Promise.all([
        getPercepciones(),
        getConfiguracionDescuentos({ estados_globales: ESTATUS_AUTORIZADO }),
      ]);
      if (mounted) {
        setTiposPercepciones(_tiposPercepcion);
        setDescuentos(_descuentos);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    setShowGrid(form.getFieldValue('se_descuenta_de_percepcion') || false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setAplicaDescuentoEnNomina(form.getFieldValue('se_considera_descuento_en_nomina') || false);
  }, [form]);
  // useEffect(() => {
  //   if (selectedPercepciones === INCIDENCIA_AUSENTISMO) {
  //     form.setFieldsValue({
  //       aplica_pago: false,
  //       se_suspende_el_pago_de_sueldo: false,
  //     });
  //   }
  //   if (selectedPercepciones === INCIDENCIA_VACACIONES) {
  //     form.setFieldsValue({
  //       aplica_descuento: false,
  //       se_suspende_el_pago_de_sueldo: false,
  //     });
  //   }
  //   if (selectedPercepciones === INCIDENCIA_PAGOLABORAL) {
  //     form.setFieldsValue({
  //       aplica_descuento: false,
  //       se_suspende_el_pago_de_sueldo: false,
  //       aplica_restar_de_dias_laborados: false,
  //       cuenta_como_dias_laborados: false,
  //     });
  //   }
  // }, [selectedPercepciones]);

  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      name="general"
      initialValues={{
        aparece_en_recibo_de_nomina: false,
        aplica_pago: false,
        aplica_descuento: false,
        se_suspende_el_pago_de_sueldo: false,
        aplica_restar_de_dias_laborados: false,
        aplica_restar_de_dias_laborados_cfdi: false,
        cuenta_como_dias_laborados: false,
        aplica_porcentaje_de_sueldo: false,
        requiere_datos_informativos: false,
        aplica_para_evaluacion_de_reloj_checador: false,
        requiere_numero_de_horas_de_la_jornada: false,
        requiere_sueldo_por_dia: false,
        requiere_sueldo_por_hora: false,
        requiere_numero_de_veces_de_pago: false,
        requiere_importe_de_pago: false,
        requiere_importe_de_descuento: false,
        se_descuenta_de_percepcion: false,
        se_considera_descuento_en_nomina: false,
        aplica_incidencia_en_horario: false,
        aplica_incidencia_en_dias_laborados: false,
        aplica_incidencia_para_descuento_en_liquidaciones: false,
        se_descuenta_del_sueldo_para_isr: false,
      }}
    >
      {/* 1. Clasificación de la incidencia */}
      <SectionCard
        number={1}
        title="Clasificación de la incidencia"
        description="¿Qué tipo de evento es?"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="es_una_incapacidad_medica"
            label="Es Incapacidad Médica"
            hasFeedback
            rules={rules.required}
            initialValue={false}
          >
            <Select
              trueFalse
              disabled={disabled}
              onChange={(value) => {
                if (!value) {
                  form.setFieldValue('requiere_folio_agrupador', false);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_folio_agrupador"
            label="Requiere Folio Agrupador"
            hasFeedback
            rules={rules.required}
            initialValue={false}
            extra="Solo aplica si Es Incapacidad Médica = Sí"
          >
            <Select trueFalse disabled={disabled || !esIncapacidadMedica} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="es_un_permiso"
            label="Es Permiso"
            hasFeedback
            rules={rules.required}
            initialValue={false}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="es_suspension_del_empleado"
            label="Es Suspensión del Empleado"
            hasFeedback
            rules={rules.required}
            initialValue={false}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_fecha_final_abierta"
            label="Requiere Fecha Final Abierta"
            hasFeedback
            rules={rules.required}
            initialValue={false}
            extra="La incidencia no tiene fecha de término definida"
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_incidencia_en_horario"
            label="Aplica Incidencia en Horario"
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_incidencia_en_dias_laborados"
            label="Aplica Incidencia en Dias Laborados"
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_para_evaluacion_de_reloj_checador"
            label="Aplica para Evaluación de Reloj Checador"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_datos_informativos"
            label="Requiere Datos Informativos"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled}
            />
          </Form.Item>
        </Col>
      </SectionCard>

      {/* 2. Efecto en días y sueldo */}
      <SectionCard
        number={2}
        title="Efecto en días y sueldo"
        description="Cómo impacta el tiempo trabajado y el pago"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="se_suspende_el_pago_de_sueldo"
            label="Se Suspende el Pago de Sueldo"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled}
            // || selectedPercepciones === INCIDENCIA_AUSENTISMO
            // || selectedPercepciones === INCIDENCIA_INCAPACIDAD
            // || selectedPercepciones === INCIDENCIA_PAGOLABORAL}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_porcentaje_de_sueldo"
            label="Aplica Porcentaje de Pago de Sueldo"
            hasFeedback
            rules={rules.required}
            extra="Permite pagar una fracción del sueldo ordinario"
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="cuenta_como_dias_laborados"
            label="Cuenta como Días Laborados"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled} // || selectedPercepciones === INCIDENCIA_PAGOLABORAL}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_restar_de_dias_laborados"
            label={(
              <div style={{ style: 'flex' }}>
                <span>Aplica Restar a Días Laborados</span>
                <Tooltip title="Implica que los días de incidencia, se restarán de los días del periodo de pago de nómina">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled} // || selectedPercepciones === INCIDENCIA_PAGOLABORAL}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_restar_de_dias_laborados_cfdi"
            label={(
              <div style={{ style: 'flex' }}>
                <span>Aplica Restar a Días Laborados CFDI</span>
                <Tooltip title="Implica que los días de incidencia se restarán, de forma independiente a 'Aplica Restar a Días Laborados', del campo Días Pagados Para CFDI en el cálculo de nómina">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
      </SectionCard>

      {/* 3. Importes y base de cálculo */}
      <SectionCard
        number={3}
        title="Importes y base de cálculo"
        description="Qué datos se requieren para calcular"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_sueldo_por_dia"
            label="Requiere Sueldo por día"
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_sueldo_por_hora"
            label="Requiere Sueldo por Hora"
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_numero_de_horas_de_la_jornada"
            label="Requiere Número de Horas de la Jornada"
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_numero_de_veces_de_pago"
            label="Requiere Número de Veces de Pago"
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_importe_de_pago"
            label="Requiere Importe de Pago"
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_importe_de_descuento"
            label="Requiere Importe de Descuento"
            hasFeedback
            rules={rules.required}
          >
            <Select trueFalse disabled={disabled} />
          </Form.Item>
        </Col>
      </SectionCard>

      {/* 4. Descuentos y pagos en nómina */}
      <SectionCard
        number={4}
        title="Descuentos y pagos en nómina"
        description="Movimientos que genera esta incidencia"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_descuento"
            label="Aplica Descuento"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled}
              // || selectedPercepciones === INCIDENCIA_VACACIONES
              // || selectedPercepciones === INCIDENCIA_INCAPACIDAD
              // || selectedPercepciones === INCIDENCIA_PAGOLABORAL}
              onChange={(value) => {
                if (value) {
                  form.setFieldsValue({
                    aplica_pago: false,
                  });
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="se_considera_descuento_en_nomina"
            label="Se Considera Descuento en Nómina"
            hasFeedback
            rules={rules.required}
            extra="Activa si el descuento debe reflejarse en el recibo"
          >
            <Select
              trueFalse
              disabled={disabled}
              onChange={(value) => {
                setAplicaDescuentoEnNomina(value);
                if (!value) {
                  form.setFieldsValue({ descuento_en_nomina: null });
                }
              }}
            />
          </Form.Item>
        </Col>
        {aplicaDescuentoEnNomina && (
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="descuento_en_nomina"
              label="Descuento de Nómina"
              rules={rules.required}
              hasFeedback
            >
              <Select
                dataSource={descuentos}
                keyProp="id"
                labelProp="clave_y_concepto"
                allowClear
                disabled={disabled}
              />
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="se_descuenta_de_percepcion"
            label="Se Descuenta de Percepción"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled}
              onChange={(value) => {
                setShowGrid(value);
                if (value) {
                  form.setFieldsValue({ se_descuenta_del_sueldo_para_isr: false });
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_pago"
            label="Aplica Pago Adicional"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled}
              // || selectedPercepciones === INCIDENCIA_AUSENTISMO
              // || selectedPercepciones === INCIDENCIA_INCAPACIDAD}
              onChange={(value) => {
                if (value) {
                  form.setFieldsValue({
                    aplica_descuento: false,
                  });
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_incidencia_para_descuento_en_liquidaciones"
            label="Aplica Incidencia para Descuento en Liquidaciones"
            hasFeedback
            rules={rules.required}
            extra="Activa si la incidencia debe ofrecerse al capturar las Incidencias de una Configuración de Liquidación"
          >
            <Select
              trueFalse
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="se_descuenta_del_sueldo_para_isr"
            label="Se Descuenta del Sueldo para ISR"
            hasFeedback
            rules={rules.required}
            extra="Activa si el importe debe descontarse de la Percepción marcada como Sueldo (Es Sueldo) para el cálculo del ISR"
          >
            <Select
              trueFalse
              disabled={disabled}
              onChange={(value) => {
                if (value) {
                  form.setFieldsValue({ se_descuenta_de_percepcion: false });
                  setShowGrid(false);
                }
              }}
            />
          </Form.Item>
        </Col>
        {showGrid && (
          <IncidenciaPercepcion
            incidenciaId={incidenciaId}
            disabled={disabled}
          />
        )}
      </SectionCard>

      {/* 5. Visualización en recibo */}
      <SectionCard
        number={5}
        title="Visualización en recibo"
        description="Qué aparece impreso al empleado"
      >
        <Col xs={24} sm={24} md={24}>
          <Form.Item
            name="aparece_en_recibo_de_nomina"
            label="Aparece en el Recibo de Nómina"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={disabled}
            />
          </Form.Item>
        </Col>
      </SectionCard>
    </Form>
  );
};

export default IncidenciaParametros;
